// Page entry. PRD 07 §1.2:
//   - METADATA:NO_PERMISSION → LNB hidden + entry blocked (rendered as the
//     NoPermissionGate below if a user navigates directly to
//     /management-guidelines).
//   - READ / WRITE / Root → see the page; component-level write checks gate
//     the CRUD controls (added in later slices).

import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { useWriteGuard } from '@/shared/hooks/useWriteGuard';
import { ManagementGuidelinesView } from '@/features/management-guidelines/components/ManagementGuidelinesView';
import { useManagementGuidelinesPageStore } from '@/features/management-guidelines/store/management-guidelines-page.store';

export function ManagementGuidelinesPage() {
  const { t } = useTranslation('management-guidelines');
  const canRead = useRequirePermission('METADATA', 'READ');
  // SHCT-582 — PRD 21 §7.4 P-2: `disabled` + 툴팁 rather than a hidden action, so a Role without
  // WRITE can still see what exists and why it is refused.
  const { canWrite, denyProps } = useWriteGuard('METADATA');
  const openCreate = useManagementGuidelinesPageStore((s) => s.openCreate);

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('title')}</h1>
        </div>
        <div className="content__actions">
          <button
            type="button"
            className="btn btn-default btn-primary"
            onClick={openCreate}
            disabled={!canWrite}
            {...denyProps}
          >
            <Plus size={16} />
            {t('addButton')}
          </button>
        </div>
      </div>
      <div className="content__body">
        <ManagementGuidelinesView />
      </div>
    </>
  );
}
